import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { CustomerContactModalComponent } from './customer-contact-modal.component';
import { CustomerContactComponent } from './customer-contact.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SendCustomerSurveyModalComponent } from './send-customer-survey-modal.component';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
    declarations: [
        CustomerContactComponent,
        CustomerContactModalComponent,
        SendCustomerSurveyModalComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        DropdownModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        MVMSpinnerBtnModule,
        RadioButtonModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerContactComponent,
        CustomerContactModalComponent,
        SendCustomerSurveyModalComponent
    ]
})

export class CustomerContactModule { }
